import { useState } from "react";
import { useNavigate } from "react-router-dom";
import WeekDaySlider from "./FieldOperationHomeComponents/fieldHomeComponent"
import AppLayout from "../AppLayout/AppLayout";
export default function SlideMenu() { 
  return (    
    <>    
     <AppLayout title="Home">
      <div style={{ padding: 16 }}>
       <WeekDaySlider />
      </div>
    </AppLayout>    
    </>

  );
}